import { render, staticRenderFns } from "./CourseCardProgress.vue?vue&type=template&id=5816864c&scoped=true"
import script from "./CourseCardProgress.vue?vue&type=script&lang=js"
export * from "./CourseCardProgress.vue?vue&type=script&lang=js"
import style0 from "./CourseCardProgress.vue?vue&type=style&index=0&id=5816864c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5816864c",
  null
  
)

export default component.exports